import { MaterialType } from '../../../models/materials.models'

import PageMaterialList from '../../../components/page/MaterialList.page'
const ListMaterialNeedPage = () => {
  return <PageMaterialList withTabs canUpdate type={MaterialType.need} />
}
export default ListMaterialNeedPage
